var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.66699 18.3749V4.62492C3.66699 4.01713 3.90843 3.43424 4.33821 3.00447C4.76798 2.57469 5.35087 2.33325 5.95866 2.33325H17.417C17.6601 2.33325 17.8933 2.42983 18.0652 2.60174C18.2371 2.77365 18.3337 3.0068 18.3337 3.24992V19.7499C18.3337 19.993 18.2371 20.2262 18.0652 20.3981C17.8933 20.57 17.6601 20.6666 17.417 20.6666H5.95866C5.35087 20.6666 4.76798 20.4251 4.33821 19.9954C3.90843 19.5656 3.66699 18.9827 3.66699 18.3749ZM3.66699 18.3749C3.66699 17.7671 3.90843 17.1842 4.33821 16.7545C4.76798 16.3247 5.35087 16.0833 5.95866 16.0833H18.3337",
    stroke: "#828997",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33301 10.5833H14.6663",
    stroke: "#828997",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33301 6.91675H12.833",
    stroke: "#828997",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCom);
export default __webpack_public_path__ + "static/media/com.28b1528cae14f53f2857dd76b4cebd87.svg";
export { ForwardRef as ReactComponent };